import React, { useState, useMemo } from 'react';
import { useIntl } from 'umi';
import { Justify } from 'tea-component';
import './index.scss';
import { useMemoizedFn } from 'ahooks';
import CardSlot from '@/pages/intelligence/components/CardSlot';
// import MarketDownloadSettings from '@/pages/intelligence/pages/MarketProfile/components/MarketDownloadSettings';
import ExportTable from '@intelligence/components/ExportTable';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';
import SearchTable from '@/pages/intelligence/pages/MarketProfile/components/MarketTableCard/SearchTable';
import MobileTable from '@/pages/intelligence/pages/MarketProfile/components/MarketTableCard/MobileTable';
import PCTable from '@/pages/intelligence/pages/MarketProfile/components/MarketTableCard/PCTable';
import AnnualTable from '@/pages/intelligence/pages/MarketProfile/components/MarketTableCard/AnnualTable';
import ChartContent from '@/pages/intelligence/pages/MarketProfile/components/MarketTableCard/ChartContent';
import { dbiBtnLogMes } from '@intelligence/utils/buriedPointCfg';
import { useQueryDefinition } from '@intelligence/hooks/useQueryDefinition';

const metricOptions = [
  {
    key: 'mscience__digitalRevenue',
    dataSource: 'mscience',
    metric: 'digitalRevenue',
    dataSourceName: {
      'en-US': 'Mscience',
      'zh-CN': 'Mscience',
    },
    metricName: 'Digital Revenue($)',
    value: 'mscience__digitalRevenue',
  },
  {
    key: 'npd__revenue',
    dataSource: 'npd',
    metric: 'revenue',
    dataSourceName: {
      'en-US': 'NPD',
      'zh-CN': 'NPD',
    },
    metricName: 'Physical Revenue($)',
    value: 'npd__revenue',
  },
];



export default function MarketTableCard(props: any) {
  const { formatMessage } = useIntl();
  const {
    title,
    iconList,
    options,
    sortbyText,
    tableData,
    activeTab,
    getChange,
    pageId,
    changeMarketProfileAll,
    selectedKeys,
    loading,
    loadingMsg = formatMessage({ id: 'common_loading' }),
    nodataMsg = formatMessage({ id: 'common_nodata' }),
    selectedMarket,
    selectSearchMarketList,
    allSearchMarketsList,
    changeSearchKeyWord = () => { },
    changeSelectedKeys = () => { },
    searchKeyWord,
    mainSegment,
    onSegmentChange,
    filterData,
    selectAllKeys,
    changeChartType = () => { },
    changeMpTableSort = () => { },
    sortColunms,
    yearData,
    mobileTableClassName,
    mapData1,
    mapData2,
    mapData3,
    mapData4,
    chartType,
    lineTrendData,
    regionsCountries,
    entityType,
  } = props;

  // const [loading, setLoading] = useState(false);
  // const [isOpen, setIsOpen] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);

  // const businessType = useMemo(() => {
  //   switch (pageId) {
  //     case 'MarketProfilPC':
  //       return 'pcMarketProfileDownload';
  //     case 'MarketProfilConsole':
  //       return 'consoleMarketProfileDownload';
  //     default:
  //       return '';
  //   }
  // }, [pageId]);

  /**
 * 获取系统级配置数据
 * countryMap：国家映射，键为国家code、值为国家信息
 * regionOptions: 地区国家列表
 */
  const { metricTableRegionCountry: regionOptions } = useQueryDefinition();

  const downloadBtnLogConfigCur = useMemo(() => {
    if (entityType === 'pc') {
      return dbiBtnLogMes?.MarketProfilePCGamesDownloadButton;
    }
    if (entityType === 'console') {
      return dbiBtnLogMes?.MarketProfileConsoleGamesDownloadButton;
    }
    return {};
  }, [entityType]);

  /**
 * 获取数据表下载的接口入参
 */
  const getDownloadReqParams = useMemoizedFn(() => {
    return {
      ...{
        page: 1,
        page_size: 9999,
        granularity: 'monthly',
        start_date: '2025-09-01',
        end_date: '2026-02-28',
        markets: ['us', 'de', 'gb', 'es', 'fr'],
        filter: {
          iegg_genre_req: [],
          gsd_types: [],
          game_count: true,
        },
        metrics: [
          'mscience__digitalRevenue',
          'mscience__units',
          'npd__revenue',
          'npd__units',
          'newzoo__total_revenue',
          'newzoo__total_players',
        ],
        order_by: ['mscience__digitalRevenue desc'],
        group_by: ['market'],
      },
      regionOptions,
      markets: selectedMarket || [],
      entity_type: entityType,
    };
  });

  return (
    <>
      <CardSlot
        className="dbi-marketprofile-tablecard"
        title={title}
        iconList={iconList}
        activeTab={activeTab}
        getChange={getChange}
      >
        {loading ? (
          <div style={{ fontSize: 14, height: 350 }}>
            <Loading content={loadingMsg} />
          </div>
        ) : selectedKeys?.length == 0 && activeTab === 'discount-chart' ? (
          <div style={{ fontSize: 14, height: 350 }}>
            <NoData content={nodataMsg} />
          </div>
        ) : (
          <ChartContent
            options={options}
            sortbyText={sortbyText}
            activeTab={activeTab}
            pageId={pageId}
            mainSegment={mainSegment}
            onSegmentChange={onSegmentChange}
            mapData1={mapData1}
            mapData2={mapData2}
            mapData3={mapData3}
            mapData4={mapData4}
            chartType={chartType}
            selectedKeys={selectedKeys}
            lineTrendData={lineTrendData}
            regionsCountries={regionsCountries}
          />
        )}
      </CardSlot>
      <Justify
        className="dbi-tablecard-justify marketTop-searchbody"
        right={
          <>
            <SearchTable
              countrieSelectList={selectSearchMarketList}
              allCountriesList={allSearchMarketsList}
              handleSearchData={(value: any) => {
                searchKeyWord.length = 0;
                searchKeyWord.push(...[value]);
                changeSearchKeyWord(searchKeyWord);
                filterData(value);
                setPageIndex(1);
              }}
              regionsCountries={regionsCountries}
            />
            {pageId !== 'MarketProfilAnnualReport' && (
              <ExportTable
                useWebDownload
                isNeedCheckedLines
                downloadModalSize={900}
                entityType={entityType}
                businessType={`marketProfile-combine`}
                newStyleFileName="Market Profile_PC&Console Games"
                // @ts-ignore
                total={tableData?.length}
                metricSelectorOptions={metricOptions} // 数据源
                isDisableDownload={loading}
                downloadBtnLogConfig={downloadBtnLogConfigCur}
                downloadKey={'combineMarketProfileTopCharts'}
                tableParams={getDownloadReqParams()}
                getCheckedLinesCfg={() => {
                  return []
                }}
              />
            )}
          </>
        }
      />

      <CardSlot>
        {loading ? (
          <div style={{ height: 400 }} className="tablecard-box">
            <Loading content={loadingMsg} />
          </div>
        ) : pageId === 'MarketProfilAnnualReport' ? (
          <AnnualTable
            entityType={entityType}
            pageId={pageId}
            tableData={tableData}
            selectedKeys={selectedKeys}
            selectAllKeys={selectAllKeys}
            changeMarketProfileAll={changeMarketProfileAll}
            changeChartType={changeChartType}
            changeMpTableSort={changeMpTableSort}
            sortColunms={sortColunms}
            changeSelectedKeys={changeSelectedKeys}
            yearData={yearData}
            regionsCountries={regionsCountries}
          />
        ) : (
          <PCTable
            entityType={entityType}
            pageId={pageId}
            tableData={tableData}
            selectedKeys={selectedKeys}
            selectAllKeys={selectAllKeys}
            changeMarketProfileAll={changeMarketProfileAll}
            changeChartType={changeChartType}
            changeMpTableSort={changeMpTableSort}
            sortColunms={sortColunms}
            changeSelectedKeys={changeSelectedKeys}
            yearData={yearData}
            regionsCountries={regionsCountries}
          />
        )}
      </CardSlot>
    </>
  );
}
